/**
 * @generated SignedSource<<37d1c7335dcaca961022386d212f2098>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateModelUpdateInput = {
  emailAddress?: string | null | undefined;
  files?: string | null | undefined;
  message?: string | null | undefined;
  modelName?: string | null | undefined;
  name?: string | null | undefined;
  phoneNumber?: string | null | undefined;
};
export type UpdatesMutation$variables = {
  input: CreateModelUpdateInput;
};
export type UpdatesMutation$data = {
  readonly createModelUpdate: {
    readonly modelUpdate: {
      readonly id: string;
    };
  };
};
export type UpdatesMutation = {
  response: UpdatesMutation$data;
  variables: UpdatesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateModelUpdatePayload",
    "kind": "LinkedField",
    "name": "createModelUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ModelUpdate",
        "kind": "LinkedField",
        "name": "modelUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdatesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdatesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "584eeabd9b4d39c3741f652061734ff9",
    "id": null,
    "metadata": {},
    "name": "UpdatesMutation",
    "operationKind": "mutation",
    "text": "mutation UpdatesMutation(\n  $input: CreateModelUpdateInput!\n) {\n  createModelUpdate(input: $input) {\n    modelUpdate {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "81e90dcb26b6e2b42624e51c32b1087c";

export default node;
